import { FC, useState, useEffect } from 'react'
import Slider from 'react-slick'
import { ProjectSliderProps as Props } from './types'
import ProjectCard from './ProjectCard'
import styles from './ProjectSlider.module.scss'

const useDragDetection = () => {
  const [mouseDown, setMouseDown] = useState(false)
  const [dragging, setDragging] = useState(false)
  const moveDragThreshold = 10

  useEffect(() => {
    let mouseMove = 0

    const handleMouseUp = () => {
      setMouseDown(false)
    }
    const handleMouseMove = (e: MouseEvent) => {
      mouseMove += Math.abs(e.movementX) + Math.abs(e.movementY)
      setDragging(mouseMove > moveDragThreshold)
    }

    if (mouseDown) {
      document.addEventListener('mouseup', handleMouseUp)
      document.addEventListener('mousemove', handleMouseMove)
    }

    return () => {
      document.removeEventListener('mouseup', handleMouseUp)
      document.removeEventListener('mousemove', handleMouseMove)
    }
  }, [mouseDown])

  const handleMouseDown = () => {
    setMouseDown(true)
    setDragging(false)
  }

  return {
    handleMouseDown,
    dragging
  }
}

const ProjectSlider: FC<Props> = ({ projects }) => {
  const { handleMouseDown, dragging } = useDragDetection()
  const handleChildClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (dragging) {
      e.preventDefault()
    }
  }

  return (
    <div className={styles['project-slider']}>
      <Slider
        infinite={false}
        slidesToShow={3}
        responsive={[
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1
            }
          }
        ]}
        dots
        dotsClass="slick-dots"
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        customPaging={() => <a />}
      >
        {projects.map((project) => {
          const { id } = project

          return (
            <div
              key={id}
              className={styles['project-card-container']}
              onMouseDownCapture={handleMouseDown}
              onClickCapture={handleChildClick}
            >
              <ProjectCard key={id} project={project} hasButton={false} />
            </div>
          )
        })}
      </Slider>
    </div>
  )
}

export default ProjectSlider
